import { render, staticRenderFns } from "./SetSignDlg.vue?vue&type=template&id=5736c6ea&"
import script from "./SetSignDlg.vue?vue&type=script&lang=js&"
export * from "./SetSignDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports